module.exports = __webpack_public_path__ + "static/img/transfer.6d0305f5.png";